import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    dbfilter: {
        dc: [],
        itemId: [],
        storeNumber: [],
        fcwNumber: [],
        ucode: [],
        productSegm: [],
        productDesc: [],
        category: [],
        subCategory: [],
        vendorName: [],
        modelType: [],
        adType: [],
    },
    selectedDbFilter: {
        dc: [],
        itemId: [],
        storeNumber: [],
        fcwNumber: ["3"],
        ucode: [],
        productSegm: [],
        productDesc: [],
        category: [],
        subCategory: [],
        vendorName: [],
        modelType: ["error based best model"],
        adType: [],
    },
    mapdc: [],
    mapstore: [],
    applyFilter: "",
    selectedFlagMarker: {
        "location": [],
        "branchId": "",
        "status": false,
        "storeNumber": 0
    },
    biasFlag: null
}

const dbfilterSlice = createSlice({
    name: "dbfilter",
    initialState: initialState,
    reducers: {
        setDBFilter: (state, action) => {
            state.dbfilter = action.payload
        },
        setSelectedDBFilter: (state, action) => {
            state.selectedDbFilter = action.payload;
        },
        setMapDC: (state, action) => {
            state.mapdc = action.payload;
        },
        setMapStore: (state, action) => {
            state.mapstore = action.payload;
        },
        setApplyFilter: (state, action) => {
            state.applyFilter = action.payload;
        },
        setSelectedFlagMarker: (state, action) => {
            state.selectedFlagMarker = action.payload;
        },
        setClearState: (state) => {
            state.mapdc = [];
            state.mapstore = [];
            state.selectedFlagMarker = {
                "location": [],
                "branchId": "",
                "status": false,
                "storeNumber": 0
            };
            state.selectedDbFilter = {
                dc: [],
                itemId: [],
                storeNumber: [],
                fcwNumber: ["3"],
                ucode: [],
                productSegm: [],
                productDesc: [],
                category: [],
                subCategory: [],
                vendorName: [],
                modelType: ["error based best model"],
                adType: [],
            };
        },
        setBiasFlag: (state, action) => {
            state.biasFlag = action.payload
        }
    }
})

export const {
    setDBFilter,
    setSelectedDBFilter,
    setMapStore,
    setMapDC,
    setApplyFilter,
    setSelectedFlagMarker,
    setClearState,
    setBiasFlag
} = dbfilterSlice.actions;

export default dbfilterSlice;